import styled, { keyframes, css } from 'styled-components';
import { Logo as LogoImage } from '../../assets';
import { COLOR } from '../../assets/constants/constants';

const defaultDiv = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 37px;
`
const maskTopBottom = keyframes`  
  0% { clip-path: polygon(0px 0px, 17px 0px, 17px 37px, 0px 37px); }
  30% { clip-path: polygon(0px 0px, 17px 0px, 17px 37px, 0px 37px); }
  100% { clip-path: polygon(0px 37px, 17px 37px, 17px 37px, 0px 37px); }
`;

const maskBottomTop = keyframes`  
  0% {  clip-path: polygon(18px 0px, 34px 0px, 34px 37px, 18px 37px); }
  30% {  clip-path: polygon(18px 0px, 34px 0px, 34px 37px, 18px 37px); }
  100% {  clip-path: polygon(18px 0px, 34px 0px, 34px 0px, 18px 0px); }
`;

const maskTopBottom2 = keyframes`  
  0% { opacity: 0; clip-path:polygon(0px 0px, 17px 0px, 17px 37px, 0px 37px); }
  30% { opacity: 1; clip-path: polygon(0px 0px, 17px 0px, 17px 37px, 0px 37px); }
  60% { opacity: 1; clip-path: polygon(0px 0px, 17px 0px, 17px 37px, 0px 37px); }
  100% { opacity: .2; clip-path: polygon(0px 37px, 17px 37px, 17px 37px, 0px 37px); }
`;

const maskBottomTop2 = keyframes`  
  0% { opacity: 0; clip-path: polygon(18px 0px, 34px 0px, 34px 37px, 18px 37px); }
  30% { opacity: 1; clip-path: polygon(18px 0px, 34px 0px, 34px 37px, 18px 37px); }
  100% { opacity: .2; clip-path: polygon(18px 0px, 34px 0px, 34px 0px, 18px 0px); }
`;


const fadeInOut = keyframes`  
  0% { opacity: 0;  }
  30% { opacity: 1; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const fadeInOut2 = keyframes`  
  0% { opacity: 0;  }
  30% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
`;

const fadeInHalf = keyframes`  
  0% { opacity: 0;  }
  100% { opacity: .2; }
`;

const pulseLogo = keyframes`
  0% { opacity: .5}
  40% { opacity: 1 }
  70% { opacity: 1 }
  100% { opacity: .5}
`

export const PreviewPanorama = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 10;
  overflow: hidden;
  opacity: 1;
  transition: all .5s ease;

  &.fadeEnd {
    opacity: 0;
  }

  &.preview-invisible{
    opacity:0; 
    pointer-events: none; 
    touch-action: none; 
    transition: all 0.5s ease-in;
    display: none !important;
  }
`

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
  transform: scale(1);
  text-align: center;
`

export const Logo = styled.div`
  ${defaultDiv}
  background: url(${LogoImage});
  animation: ${pulseLogo} 2s ease-out infinite;
`

export const Step1Left = styled.div`
  ${defaultDiv}
  background: url(${LogoImage});
  background-size: 34px 37px;
  clip-path: polygon(0px 0px, 17px 0px, 17px 37px, 0px 37px);
  opacity: ${props => props.anim === "step2" ? 0: 1};
  animation-name: ${props => props.anim === "step2" ? maskTopBottom2: maskTopBottom};
  animation-delay: ${props => props.delay || 0}s;
  animation-duration: 1.5s;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  z-index: 3;
`

export const Step1Right = styled.div`
  ${defaultDiv}
  background: url(${LogoImage});
  background-size: 34px 37px;
  clip-path: polygon(18px 0px, 34px 0px, 34px 37px, 18px 37px);
  opacity: ${props => props.anim === "step2" ? 0: 1};
  animation-name: ${props => props.anim === "step2" ? maskBottomTop2: maskBottomTop};
  animation-delay: ${props => props.delay || 0}s;
  animation-duration: 1.5s;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  z-index: 2;
`
export const Step2FadeInOut = styled.div`
  ${defaultDiv}
  background: url(${LogoImage});
  background-size: 34px 37px;
  clip-path: polygon(0px 0px, 34px 0px, 34px 37px, 0px 37px);
  animation-name: ${fadeInOut};
  animation-delay: ${props => props.delay || 0}s;
  animation-duration: 2.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  z-index: 1;
`

export const Step3FadeInOut = styled.div`
  ${defaultDiv}
  background: url(${LogoImage});
  background-size: 34px 37px;
  clip-path: polygon(0px 0px, 34px 0px, 34px 37px, 0px 37px);
  animation-name: ${fadeInOut2};
  animation-delay: ${props => props.delay || 0}s;
  animation-duration: 2.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  z-index: 1;
`

export const StepAllFadeInO = styled.div`
  ${defaultDiv}
  background: url(${LogoImage});
  background-size: 34px 37px;
  clip-path: polygon(0px 0px, 34px 0px, 34px 37px, 0px 37px);
  animation-name: ${fadeInHalf};
  animation-delay: ${props => props.delay || 0}s;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  z-index: 0;
`

export const Container = styled.div`
  position: relative;
  opacity: 1;
  background: ${p => p.dark ? COLOR.secondary : 'transparent'};
  transition: all .5s ease;
  z-index: 11;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(29,55,57,0.8);
    z-index: 0;
  }

  &.opacity-05{
    opacity: 0.9;
    pointer-events: none;
    touch-action: none;
    transition: all 0.5s ease-in;
  }


  &.fadeEnd {
    opacity: 0;
  }

  &.preview-invisible{
    opacity:0; 
    pointer-events: none; 
    touch-action: none; 
    transition: all 0.5s ease-in;
    display: none !important;
  }
`